module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sloqPr/tc-custom/9781488086892.jpg?1728725526274",
      "alt": "This image is the cover for the book Her Convenient Husband's Return"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Convenient Husband's Return\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A marriage in name only leads to unexpected passion in a Regency romance that shows what happens when the heart clashes with the head.")]), _c('br'), _c('br'), _c('i', [_vm._v("Her husband is back—and everything has changed . . .")]), _c('br'), _c('br'), _vm._v("After Beth Webster married her childhood friend to escape from debt, he swiftly returned to his life in London. But now Rendell Graham is back as lord of the estate, and Beth’s heart pounds whenever he is near! She’s wary of expectations to produce an heir, for fear of passing on her blindness. But Ren’s hidden sensitivity is a surprise—could their arrangement become something much more passionate?"), _c('br'), _c('br'), _c('b', [_vm._v("“[A] very engaging historical story . . . original and highly entertaining.” —"), _c('i', [_vm._v("alwaysreviewing.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eleanor Webster\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0